ACC.addressBookSearchFunctionality = {
  addressSearch: function() {
    /* eslint-disable  no-undef */
    var markInstance = new Mark(document.querySelector('#cboxContent .context'));
    var keywordInput = document.querySelector('#cboxContent #myInput');

    function performMark() {
      var keyword = String(keywordInput.value);

      var listSelector = document.querySelectorAll('.ph-list');

      [].forEach.call(listSelector, function(element) {
        element.parentNode.style.display = '';
      });
      markInstance.unmark();

      if (keyword.length > 0) {
        markInstance.mark(keyword, {
          done: function() {
            $('.context').find('.ph_hidesection').hide();
            $('.context').find('.ph_hidesection').find('.ph-list:has(mark)').parent().show();

            if ($('.ph-list').parents('.ph_hidesection').not(':has(mark)').is(':hidden')) {
              if ($('#cboxWrapper .ph_hidesection').is(':visible')) {
                $('.ph-resultnotfound').hide();
              } else {
                $('.ph-resultnotfound').css({
                  display: 'inline-block',
                  'vertical-align': 'top',
                  'min-height': '20px'
                });
              }
            } else {
              $('.ph-resultnotfound').hide();
            }
          },
          exclude: ['a']
        });
      } else {
        $('.ph-resultnotfound').hide();
      }
    }

    if (document.querySelectorAll('#myInput').length > 0) {
      keywordInput.addEventListener('input', performMark);
    }
  /* eslint-enable  no-undef */
  }
};
